import { Button, Col, Form, message, Modal, Row } from "antd";
import FormSelect from "component/form/form_select";
import { useComputer } from "hook/base/computer/useComputerAction";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultComputerOpenAddSelector } from "store/bailiff/(default)/computer/default_computer.selector";
import { MACHINE_OPTIONS } from "store/string";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogMachineAdd = () => {
  // -------------------------- VAR -----------------------------
  const [form] = Form?.useForm();
  const { handleClose, handleAddMachine } = useComputer();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(defaultComputerOpenAddSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      footer={null}
      centered
      open={open}
      onCancel={handleClose}
      title="Thêm máy chủ ảo"
    >
      <Form layout="vertical" form={form} id="dialog-add-machine">
        <Row>
          <Col xl={24} lg={24} md={24} xs={24}>
            <FormSelect
              name="worker"
              label="Select Worker"
              placeholder="Lựa chọn worker để thêm"
              options={MACHINE_OPTIONS}
              rules={[{ required: true, message: "Làm ơn chọn worker" }]}
            />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Button
              onClick={() => handleAddMachine(form)}
              style={{ minHeight: 40 }}
              type="primary"
              block
            >
              Confirm
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default DialogMachineAdd;
